<template>
  <span
    data-node-content
    data-cy="unrecognised-item"
    class="rounded-sm border border-dashed border-gray-300 p-1"
    :class="isEmpty(node.error) ? 'text-gray-600' : 'text-error'"
  >
    {{ node.content }}
  </span>
</template>
<script lang="ts" setup>
import isEmpty from "lodash/isEmpty";

import type { EditorNode } from "@/models/TextEditor";

defineProps<{
  node: EditorNode;
}>();
</script>
